var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","disabled":!_vm.photo},on:{"click":_vm.edit}},on),[_c('v-icon',[_vm._v("fa fa-edit")])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm._f("t")('photo.action.edit_name')))])])}
var staticRenderFns = []

export { render, staticRenderFns }